"use client";
import Image from "next/image";
import Link from "next/link";

export function Footer() {
  return (
    <footer className="w-full bg-background text-white font-serif">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="h-24 flex items-start justify-between gap-4 pt-4">
          <div className="flex items-center gap-2">
            <Image
              src="/images/lema-logo.png"
              alt="Lema logo"
              width={24}
              height={24}
              className="h-6 w-6 object-contain filter brightness-0 invert"
              priority
            />
          </div>
          <div className="flex items-center gap-4 text-xs opacity-80">
            <Link href="/terms" prefetch={false} className="underline underline-offset-4 hover:opacity-100">
              Terms of Service
            </Link>
            <Link href="/privacy" prefetch={false} className="underline underline-offset-4 hover:opacity-100">
              Privacy Policy
            </Link>
          </div>
          <div className="text-xs opacity-80">
            <span> {new Date().getFullYear()} Lema. All Rights Reserved.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
